import React, {useState, useEffect, useRef} from "react";
import styled from "styled-components";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { targetCrops } from "../data/fireblightOptionData";
import { getRegionSido, getWeeklyBirMaxCount, getWeeklySidoBirMaxCountAsync, getSendCountAsync } from "../context/api_alimtalk";

import * as XLSX from "xlsx";

import "../css/common.css";
import "../css/layout.css";
import axios from "axios";

ModuleRegistry.registerModules([AllCommunityModule]);

const REGION_ORDER = [
    { cd: '41', name: '경기' },
    { cd: '51', name: '강원' },
    { cd: '43', name: '충북' },
    { cd: '44', name: '충남' },
    { cd: '52', name: '전북' },
    { cd: '46', name: '전남' },
    { cd: '47', name: '경북' },
    { cd: '48', name: '경남' },
    { cd: '11', name: '서울' },
    { cd: '26', name: '부산' },
    { cd: '27', name: '대구' },
    { cd: '28', name: '인천' },
    { cd: '29', name: '광주' },
    { cd: '30', name: '대전' },
    { cd: '31', name: '울산' },
    { cd: '36', name: '세종' },
];


const getLastMonday = () => {
    const today = new Date();
    const day = today.getDay();
    const diff = day === 0 ? 6 : day - 1;
    const thisMonday = new Date(today);
    thisMonday.setDate(today.getDate() - diff);
    const lastMonday = new Date(thisMonday);
    lastMonday.setDate(thisMonday.getDate() - 7);
    return lastMonday;
};

const getLastSunday = () => {
    const lastSunday = new Date(getLastMonday());
    lastSunday.setDate(lastSunday.getDate() + 6);
    return lastSunday;
};

const toDateString = (date) => date.toISOString().slice(0, 10);

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
`;

const TopBar = styled.div`
    display: flex;
    align-items: center;
    background: #2d66af;
    padding: 0 16px;
    height: 50px;
    flex-shrink: 0;
    gap: 12px;
`;

const TopBarTitle = styled.h1`
    color: #fff;
    font-size: 0.95em;
    font-weight: bold;
    margin: 0;
    white-space: nowrap;
`;

const TopBarDivider = styled.div`
    width: 1px;
    height: 24px;
    background: rgba(255, 255, 255, 0.35);
    flex-shrink: 0;
`;

const SearchLabel = styled.span`
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    white-space: nowrap;
`;

const TopBarSelect = styled.select`
    font-size: 13px;
    padding: 3px 8px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    height: 30px;
    cursor: pointer;

    option {
        background: #2d66af;
        color: #fff;
    }
`;

const TopBarInput = styled.input`
    font-size: 13px;
    padding: 3px 8px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    height: 30px;
    cursor: pointer;
    colorscheme: dark;
`;

const TopBarButton = styled.button`
    font-size: 13px;
    padding: 3px 16px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.25);
    color: #fff;
    height: 30px;
    cursor: pointer;

    &:hover {
        background: rgba(255, 255, 255, 0.4);
    }
`;

const GridArea = styled.div`
    flex: 1;
    min-height: 0;
    padding: 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    gap: 16px;

    .ag-cell {
        color: #000 !important;
        font-weight: 400 !important;
    }
    .ag-header-cell-text {
        color: #000 !important;
        font-weight: 450 !important;
    }
`;

function WeeklyFireblight() {
    const [startDate, setStartDate] = useState(toDateString(getLastMonday()));
    const [endDate, setEndDate] = useState(toDateString(getLastSunday()));
    // const [startDate, setStartDate] = useState("2025-04-21");
    // const [endDate, setEndDate] = useState("2025-04-27");
    const [sidoList, setSidoList] = useState([]);
    const [selectedSido, setSelectedSido] = useState("");
    const [selectedCrop, setSelectedCrop] = useState(targetCrops[0]);
    const [sidoRowData, setSidoRowData] = useState([]);
    const [sigunguRowData, setSigunguRowData] = useState([]);

    const [displayCrop, setDisplayCrop] = useState(targetCrops[0]);

    const sidoGridRef = useRef(null);
    const sigunguGridRef = useRef(null);

    const nullFormatter = (params) => params.value == null ? '-' : params.value;

    const sidoColumnDefs = [
        { field: "regionMain", headerName: "지역", flex: 1 },
        {
            headerName: "위험도 경보",
            children: [
                { field: "bir3CountMax", headerName: "3단계", valueFormatter: nullFormatter, flex: 1 },
                { field: "bir4CountMax", headerName: "4단계", valueFormatter: nullFormatter, flex: 1 },
            ]
        },
        { field: "sigunguCountStrings", headerName: "시군명", flex: 2 },
        { field: "sendCount", headerName: "알림발송건수", flex: 1 },
    ];

    const sigunguColumnDefs = [
        { field: "regionMain", headerName: "지역", spanRows: true, flex: 1 },
        { field: "regionDesc", headerName: "시군", flex: 1 },
        {
            headerName: "위험도 경보",
            children: [
                { field: "bir3CountMax", headerName: "3단계", valueFormatter: nullFormatter, flex: 1 },
                { field: "bir4CountMax", headerName: "4단계", valueFormatter: nullFormatter, flex: 1 },
            ]
        },
    ];

    const fetchSidoWithSendCount = async (sidoParams, sendParams) => {
        try {
            const [sidoData, sendData] = await Promise.all([
                getWeeklySidoBirMaxCountAsync(sidoParams),
                getSendCountAsync(sendParams),
            ]);
            setSidoRowData(fillMissingRegions(sidoData, sendData));
        } catch (e) {
            alert("데이터 조회에 실패하였습니다.");
        }
    };

    const fillMissingRegions = (sidoData, sendCountData) => {
        const sidoMap = Object.fromEntries(sidoData.map(d => [d.regionMainCd, d]));
        const sendMap = Object.fromEntries(sendCountData.map(d => [d.regionMainCd, d.count]));
        return REGION_ORDER.map(({ cd, name }) => ({
            ...(sidoMap[cd] ?? {
                regionMainCd: cd,
                regionMain: name,
                regionCount: 0,
                bir3CountMax: null,
                bir4CountMax: null,
                sigunguCountStrings: null,
            }),
            sendCount: sendMap[cd] ?? 0,
        }));
    };

    useEffect(() => {
        getRegionSido(setSidoList, console.error);
        const initStart = toDateString(getLastMonday());
        const initEnd = toDateString(getLastSunday());

        fetchSidoWithSendCount(
            { start: initStart, end: initEnd, plant: targetCrops[0].title },
            { start: initStart, end: initEnd, plant: targetCrops[0].title }
        );
        getWeeklyBirMaxCount(setSigunguRowData, console.error, { start: initStart, end: initEnd, plant: targetCrops[0].title });
    }, []);

    const onClickSearch = () => {
        if (!validateDates(startDate, endDate)) return;

        fetchSidoWithSendCount(
            { start: startDate, end: endDate, plant: selectedCrop.title, ...(selectedSido && { region_main_cd: selectedSido }) },
            {  start: startDate, end: endDate, plant: selectedCrop.title }
        );
        getWeeklyBirMaxCount(setSigunguRowData, console.error, { start: startDate, end: endDate, plant: selectedCrop.title, regionMainCd: selectedSido });
        setDisplayCrop(selectedCrop);
    };

    const onClickDownload = () => {
        const sidoData = sidoRowData.map((item) => ({
            지역: item.regionMain,
            "3단계": item.bir3CountMax ?? "-",
            "4단계": item.bir4CountMax ?? "-",
            시군명: item.sigunguCountStrings,
            알림발송건수: item.sendCount ?? 0,  // ← 추가
        }));

        const sigunguData = sigunguRowData.map((item) => ({
            지역: item.regionMain,
            시군: item.regionDesc,
            "3단계": item.bir3CountMax ?? "-",
            "4단계": item.bir4CountMax ?? "-",
        }));

        const wb = XLSX.utils.book_new();
        const sidoSheet = XLSX.utils.json_to_sheet(sidoData);
        const sigunguSheet = XLSX.utils.json_to_sheet(sigunguData);

        XLSX.utils.book_append_sheet(wb, sidoSheet, `${selectedCrop.titleKo}-시도별`);
        XLSX.utils.book_append_sheet(wb, sigunguSheet, `${selectedCrop.titleKo}-시군별`);

        XLSX.writeFile(wb, `주간화상병_${selectedCrop.titleKo}_${startDate}_${endDate}.xlsx`);
    };

    const MIN_DATE = "2017-03-01";
    const maxEndDate = toDateString(new Date(new Date().setDate(new Date().getDate() + 7)));

    const validateDates = (start, end) => {
        const s = new Date(start);
        const e = new Date(end);
        const diff = (e - s) / (1000 * 60 * 60 * 24);
        if (diff > 365) {
            alert("조회 기간은 최대 1년입니다.");
            return false;
        }
        if (diff < 0) {
            alert("종료일이 시작일보다 빠를 수 없습니다.");
            return false;
        }
        return true;
    };

    return (
        <PageWrapper>
            <TopBar>
                <TopBarTitle>주간 화상병 꽃감염 위험도 집계</TopBarTitle>
                <TopBarDivider />
                <SearchLabel>조회 조건</SearchLabel>
                <TopBarSelect value={selectedCrop ? selectedCrop.id : ""} onChange={(e) => {
                    const target = targetCrops.find((c) => c.id == e.target.value);
                    if (target) setSelectedCrop(target);
                }}>
                    {targetCrops.map((crop) => (
                        <option key={crop.id} value={crop.id}>{crop.titleKo}</option>
                    ))}
                </TopBarSelect>
                <TopBarSelect value={selectedSido} onChange={(e) => setSelectedSido(e.target.value)}>
                    <option value="">전체</option>
                    {sidoList.map((s, index) => (
                        <option key={index} value={s.regionMainCd}>{s.regionMain}</option>
                    ))}
                </TopBarSelect>
                <TopBarInput type="date" value={startDate} min={MIN_DATE} max={endDate} onChange={(e) => setStartDate(e.target.value)} />
                <SearchLabel>~</SearchLabel>
                <TopBarInput type="date" value={endDate} min={startDate} max={maxEndDate} onChange={(e) => setEndDate(e.target.value)} />
                <TopBarButton onClick={onClickSearch}>조회</TopBarButton>
                <TopBarButton onClick={onClickDownload}>다운로드</TopBarButton>
            </TopBar>

            <GridArea>
                {/* 시도 그리드 */}
                <div style={{ flex: 2, minHeight: 0, display: "flex", flexDirection: "column" }}>
                    <h4 style={{ margin: "0 0 8px 0" }}>({displayCrop.titleKo}) 꽃감염위험도 3·4단계 발생 현황</h4>
                    <div className="ag-theme-alpine" style={{ flex: 1, width: "100%" }}>
                        <AgGridReact
                            ref={sidoGridRef}
                            rowData={sidoRowData}
                            columnDefs={sidoColumnDefs}
                            overlayNoRowsTemplate="<span>해당 기간 3·4단계 경보 데이터가 없습니다.</span>"
                        />
                    </div>
                    <p style={{ margin: "8px 0 0 0", fontSize: "10px", color: "#666", flexShrink: 0 }}>
                        * 주간 꽃감염위험도 발생 현황 데이터 추출 방법<br/>
                        &nbsp;&nbsp;1) 꽃감염위험도 3·4단계 발생 현황: 시군별 꽃감염 위험도 경보(3단계/4단계 구분)의 합산<br/>
                        &nbsp;&nbsp;2) 시군별 꽃감염 위험도 경보: 시군 내 지점들의 주간 경보(3·4단계) 횟수의 최대값
                    </p>
                </div>

                {/* 시군 그리드 */}
                <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
                    <h4 style={{ margin: "0 0 8px 0" }}>({displayCrop.titleKo}) 시군별 꽃감염위험도 발생 현황</h4>
                    <div className="ag-theme-alpine" style={{ flex: 1, width: "100%" }}>
                        <AgGridReact
                            ref={sigunguGridRef}
                            rowData={sigunguRowData}
                            columnDefs={sigunguColumnDefs}
                            enableCellSpan={true}
                            overlayNoRowsTemplate="<span>해당 기간 3·4단계 경보 데이터가 없습니다.</span>"
                        />
                    </div>
                </div>
            </GridArea>
        </PageWrapper>
    );
}

export default WeeklyFireblight;